import Cookies from 'js-cookie';
import dayjs from 'dayjs';
import { AuthSignedInUserResponseProps } from '../../types/user';
import { useDispatch } from 'react-redux';
import { setUser } from '../../redux/user/userSlice';
import { buildUserFromLoginData } from '../../components/Buttons/utils';

export const useSetLoginData = () => {
  const dispatch = useDispatch();

  const setLoginData = (data: AuthSignedInUserResponseProps) => {
    Cookies.set('id', data.id, { expires: 14 });
    localStorage.setItem('accessToken', data.accessToken);
    localStorage.setItem('accessTokenCreatedAt', dayjs().toISOString());

    const isDevEnv = process.env.NODE_ENV === 'development';

    if (isDevEnv && data.refreshTokenForWebDevEnv) {
      Cookies.set('refreshToken', data.refreshTokenForWebDevEnv, {
        expires: 14,
        secure: false,
        sameSite: 'lax',
      });
    }

    dispatch(
      setUser(
        buildUserFromLoginData({
          ...data,
          isLoggedIn: true,
        }),
      ),
    );
  };

  return {
    setLoginData,
  };
};
